<template>
	<section class="app-main">

    <div class="notice-card-wrapper" v-if="showTip === 1">
      <div class="header">
        <div class="title">
          <!-- 系统公告 -->
          <div class="message">
            <div class="inner-container">
              <i class="el-icon-warning-outline" style="color: #e6a23c;"></i>
              <span v-text="notice"></span>
            </div>
          </div>
        </div>
      </div>
    </div>

		<transition name="fade-transform" mode="out-in">
			<!-- 将不需要缓存的组件name添加到exclude -->

			<keep-alive v-if="!$route.meta.noCache">
				<router-view :key="key" />
			</keep-alive>
			<!-- 将不需要缓存的页面的路由的元信息里面加上一个noCache字段值为true -->
			<router-view v-if="$route.meta.noCache" :key="key" />
		</transition>
	</section>
</template>

<script>
import { mapState } from 'vuex'

export default {
	name: 'AppMain',
	data () {
		return {
			notice: '商户授权时间将要过期，请联系管理员'
		}
	},
	computed: {
		// cachedViews() {
		// 	return this.$store.state.tagsView.cachedViews;
		// },
		key () {
			return this.$route.path
		},
		...mapState({
			showTip: (state) => state.user.userInfo.showTip
		})
	}
}
</script>

<style lang="scss" scoped>
.fixed-header + .app-main {
	// padding-top: 50px;
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
	.fixed-header {
		padding-right: 15px;
	}
}

.notice-card-wrapper {
  font-size: 12px;
  .inner-container {
    margin-left: 100%; // 把文字弄出可见区域
    width: 200%;
    animation: myMove 20s linear infinite; // 重点，定义动画
    animation-fill-mode: forwards;
  }
  /*文字无缝滚动*/
  @keyframes myMove {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-1950px);
    }
  }
}
</style>
